import { render, staticRenderFns } from "./HelpPrompt.vue?vue&type=template&id=72414686&scoped=true&lang=html&"
import script from "./HelpPrompt.vue?vue&type=script&lang=js&"
export * from "./HelpPrompt.vue?vue&type=script&lang=js&"
import style0 from "./HelpPrompt.vue?vue&type=style&index=0&id=72414686&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72414686",
  null
  
)

export default component.exports